/**
 * CDN URL 생성 유틸리티
 *
 * WordPress 업로드 파일이나 기타 S3 캐시 파일에 대한 CDN URL을 생성합니다.
 */

/**
 * S3 캐시 CDN의 기본 URL을 반환합니다.
 */
export function getCdnBaseUrl(): string {
  const cdnDomain = process.env.NEXT_PUBLIC_AWS_S3_CACHE_CDN_DOMAIN;
  if (!cdnDomain) {
    throw new Error(
      'NEXT_PUBLIC_AWS_S3_CACHE_CDN_DOMAIN 환경 변수가 설정되지 않았습니다.',
    );
  }

  return `https://${cdnDomain}`;
}

/**
 * 상대 경로를 CDN URL로 변환합니다.
 *
 * @param path - CDN 기본 URL 이후의 경로 (예: '/wp-content/uploads/2024/06/file.pdf')
 * @returns 전체 CDN URL
 *
 * @example
 * getCdnUrl('/wp-content/uploads/2024/06/file.pdf')
 * // => 'https://cdn.example.com/wp-content/uploads/2024/06/file.pdf'
 */
export function getCdnUrl(path: string): string {
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${getCdnBaseUrl()}${normalizedPath}`;
}

/**
 * WordPress 업로드 파일의 CDN URL을 생성합니다.
 *
 * @param filePath - wp-content/uploads 이후의 파일 경로 (예: '2024/06/26071948/file.pdf')
 * @returns 전체 CDN URL
 *
 * @example
 * getWpUploadsCdnUrl('2024/06/26071948/3billion-Company-Introduction-kor.pdf')
 * // => 'https://cdn.example.com/wp-content/uploads/2024/06/26071948/3billion-Company-Introduction-kor.pdf'
 */
export function getWpUploadsCdnUrl(filePath: string): string {
  const normalizedPath = filePath.startsWith('/')
    ? filePath.slice(1)
    : filePath;
  return getCdnUrl(`/wp-content/uploads/${normalizedPath}`);
}
